import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function DropdownField({
  label,
  name,
  options,
  value,
  onChange,
  placeholder = "Select",
  required = false,
  className = "",
  disabled = false, 
  error,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selected = options.find((opt) => String(opt.value) === String(value));

  const handleSelect = (option) => {
    if (disabled) return; 
    onChange({ target: { name, value: String(option.value) } });
    setIsOpen(false);
  };

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium mb-2 text-primary-dark"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <button
          id={name}
          type="button"
          onClick={() => !disabled && setIsOpen(!isOpen)} // 🔒 jangan toggle kalau disable
          className={`w-full flex items-center justify-between py-3 px-4 border rounded-lg text-base shadow-sm focus:outline-none
            ${
              disabled
                ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-primary/30"
            }`}
          disabled={disabled}
        >
          {selected ? selected.label : placeholder}
          {isOpen && !disabled ? (
            <ChevronUp size={18} className="ml-2 text-gray-500" />
          ) : (
            <ChevronDown size={18} className="ml-2 text-gray-500" />
          )}
        </button>

        {/* Hanya render dropdown kalau enabled */}
        {isOpen && !disabled && (
          <div className="absolute z-10 mt-2 w-full bg-white rounded-lg shadow border border-gray-100">
            <ul className="py-1 text-sm text-gray-700">
              {options.map((opt) => (
                <li key={opt.value}>
                  <button
                    type="button"
                    className="w-full text-left block px-4 py-2 hover:bg-primary/10"
                    onClick={() => handleSelect(opt)}
                  >
                    {opt.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
